import { ReactElement } from 'react';

import { HiddenContainer } from './style';

export interface HiddenProps {
	hidden?: boolean;
	children: ReactElement;
}

export function Hidden({ children, hidden }: HiddenProps) {
	return <HiddenContainer hidden={hidden}>{children}</HiddenContainer>;
}
